/**
 * Alternate entry points for the same base environment - "app-green.sstid.com",
 * "app-candidate.sstid.com", etc. all mean "app", just via a different deployment slot/route.
 * "candidate" is the current name; "green"/"blue" are older ones still in use (see
 * getEnvironment.js's stripRouteSuffix and getMqttBrokerHostname.js).
 *
 * Kept in exactly one place so the two independent consumers above can't drift out of step on
 * which suffixes count - that drift (getMqttBrokerHostname.js knew about green/blue but not
 * candidate) is what left app-candidate.sstid.com resolving to a nonexistent EMQX broker host
 * even after green/blue were fixed (#1701).
 *
 * Both consumers interpolate these into a `new RegExp(...)`, so every value must be a literal
 * word: a regex metacharacter here would silently change what the pattern matches rather than
 * failing. This list stops the two from disagreeing about *which* suffixes count - it does not
 * make them match identically in every respect (getMqttBrokerHostname lower-cases its input
 * first, getEnvironment relies on its caller already having done so).
 */
export const DEPLOYMENT_SLOT_SUFFIXES = ['green', 'blue', 'candidate'];
